var map = {
	"./AUD.png": 5783,
	"./CNY.png": 6869,
	"./EUR.png": 2021,
	"./GBP.png": 6053,
	"./HKD.png": 8278,
	"./JPY.png": 3510,
	"./KRW.png": 3220,
	"./THB.png": 1711,
	"./USD.png": 7602,
	"./VND.png": 4584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9967;